import { applyMiddleware, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { isDevEnv } from '../settings/environment'
import reducers from './reducers'
import { enhanceReduxMiddleware } from 'kepler.gl/middleware'

/**
 * Factory to create a new store instance as a singleton.
 */
const factoryStore = (initialState = {}) => {
  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 5 })
  const middlewares = enhanceReduxMiddleware([thunkMiddleware])
  const enhancers = isDevEnv
    ? composeEnhancers(applyMiddleware(...middlewares))
    : compose(applyMiddleware(...middlewares))
  // const middleware = isDevEnv
  //   ? composeEnhancers(applyMiddleware(thunkMiddleware))
  //   : compose(applyMiddleware(thunkMiddleware))
  const store = createStore(reducers, initialState, enhancers)

  return () => store
}

/**
 * Gets the current store instance.
 */
const storeSingleton = factoryStore()

export default storeSingleton
